/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import "./tasks.css";
import TaskList from "../../components/taskList/taskList";
import TaskBoards from "../../components/taskBoards/taskBoards";
import Cookies from "js-cookie";
import { TASK_LIST_URL } from "../../global/API";
import EventCalendar from "../../components/eventCalendar/eventCalendar";
import { events } from "../../global/API";
import CustomModal from "../../components/customModal/customModal";
import { Image } from "primereact/image";
import { Calendar } from "primereact/calendar";
import { Editor } from "primereact/editor";
import { formatDateTime, formatDateTimeNew } from "../../components/globalFunctions/globalFunctions";
import { formatDate } from "date-fns";
const customModules = {
  toolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], [{ align: [] }], ["link", "image"]],
  // toolbar: [[{ header: [1, 2, 3, false] }], ["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], [{ align: [] }], ["link", "image"], ["clean"]],
};

const Tasks = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [taskView, setTaskView] = useState("List");
  const [modifiedTaskDetails, setModifiedTaskDetails] = useState({});
  const [getModalLayout, setGetModalLayout] = useState(null);
  const [activityTab, setActivityTab] = useState(1);
  const [viewTask, setViewTask] = useState([]);
  const [activeEditor, setActiveEditor] = useState(false);

  const [dates, setDates] = useState(null);
  const [text, setText] = useState("");

  const getData = async (status = null, page = 1) => {
    const jwtToken = Cookies.get("jwtToken");
    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
    };

    let query = `?limit=100&page=${page}${status ? "&task_status=" + status : ""}`;

    const URL = TASK_LIST_URL + query;

    try {
      const response = await fetch(URL, options);
      if (response.ok) {
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    const statusList = await getData();
    const updatedStatusList = statusList.task_status_list.map((eachStatus, idx) => ({ ...eachStatus, order: idx }));
    const totalData = {};
    const statusData = await Promise.all(
      statusList?.task_status_list.map(async (item) => {
        totalData[item?.task_status.replace(/\s+/g, "")] = await getData(item?.task_status);
      })
    );
    setTaskList(() => ({ statusList: updatedStatusList, ...totalData }));

    setIsLoading(false);
  };

  // const fetchData = async () => {
  //   const jwtToken = Cookies.get("jwtToken");
  //   const options = {
  //     method: "GET",
  //     headers: { Authorization: `Bearer ${jwtToken}` },
  //   };
  //   const URL = TASK_LIST_URL;
  //   try {
  //     const response = await fetch(URL, options);
  //     if (response.ok) {
  //       const data = await response.json();
  //       setTaskList(data);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    fetchData();
  }, [modifiedTaskDetails]);

  const renderTaskDetails = (item) => {
    const { id, title, dueDate, sub_tasks } = item;
    const subTabList = ["sub task 1", "add sub task", "add sub task 2"];

    const renderTaskDetailLayout = () => {
      return (
        <div className="tab-content" id="v-pills-tabContent">
          <div className="tab-pane fade show active" id="task-data" role="tabpanel" aria-labelledby="task-data-tab" tabIndex="0">
            <h2>{title}</h2>
            <form>
              <div className="form-group-grid">
                <div className="form-group">
                  <label className="form-label">
                    <i className="ri-creative-commons-sa-line"></i> Status
                  </label>
                  <select className="form-select" aria-label="Default select example">
                    <option defaultValue>Todo</option>
                    <option value="1">Testing</option>
                    <option value="2">New</option>
                    <option value="3">Complete</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">
                    <i className="ri-user-line"></i> Assignees
                  </label>
                  <select className="form-select">
                    <option defaultValue>Empty</option>
                    <option value="1">Name</option>
                    <option value="2">Name</option>
                    <option value="3">Name</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">
                    <i className="ri-calendar-2-fill"></i> Dates
                  </label>
                  <Calendar value={dueDate} readOnlyInput hideOnRangeSelection placeholder={formatDateTimeNew(dueDate)} dateFormat="M dd, yy" showButtonBar showIcon />
                </div>
                <div className="form-group">
                  <label className="form-label">
                    <i className="ri-arrow-up-down-fill"></i> Relationships
                  </label>
                  <input type="text" className="form-control" placeholder="Empty" />
                </div>
              </div>
              <div className="form-group mb-5 mt-3">
                <Editor value={text} onTextChange={(e) => setText(e.htmlValue)} className="texteditor" />
              </div>

              <div className="subtasks-list" role="tablist">
                <button className="nav-link active" id="customField-tab" data-bs-toggle="pill" data-bs-target="#customField" type="button" role="tab" aria-controls="customField" aria-selected="true">
                  Custom Fields
                </button>
                <button className="nav-link" id="subTask-tab" data-bs-toggle="pill" data-bs-target="#subTask" type="button" role="tab" aria-controls="subTask" aria-selected="false">
                  Subtasks
                </button>
                <button className="nav-link" id="AttachmentTab-tab" data-bs-toggle="pill" data-bs-target="#AttachmentTab" type="button" role="tab" aria-controls="AttachmentTab" aria-selected="false">
                  Attachments
                </button>
              </div>
              <div className="tab-content">
                <div className="tab-pane fade show active" id="customField" role="tabpanel" aria-labelledby="customField-tab" tabIndex="0">
                  <ul className="custom-field-list">
                    <li>
                      <i className="ri-text"></i> Name
                    </li>
                    <li>
                      <i className="ri-phone-line"></i> Phone
                    </li>
                    <li>
                      <i className="ri-mail-line"></i> Email
                    </li>
                    <li>
                      <i className="ri-global-line"></i> Website
                    </li>
                  </ul>
                  <button className="custom-field-add-btn">
                    <i className="ri-add-line"></i> Create Custom Fields
                  </button>
                </div>
                <div className="tab-pane fade" id="subTask" role="tabpanel" aria-labelledby="subTask-tab" tabIndex="0">
                  <div className="table-responsive edit-table">
                    <table className="table align-middle text-nowrap table-hover ">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Assignee</th>
                          <th>Due Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Subtask 1</td>
                          <td>Chandra</td>
                          <td>Jul 30, 2025</td>
                          <td>
                            <a href="" className="ri-delete-bin-7-line"></a>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <i className="ri-add-line"></i> Add Task
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="tab-pane fade" id="AttachmentTab" role="tabpanel" aria-labelledby="AttachmentTab-tab" tabIndex="0">
                  <div className="attachment-gallery">
                    <div className="attachment-gallery-item">
                      <figure>
                        <Image src="./assets/images/customer-bg.jpg" alt="Image" preview />
                      </figure>
                      <div className="content">
                        <p>Jul 10 at 10:00 am</p>
                        <span className="attachment-agent-name">RK</span>
                      </div>
                    </div>
                    <div className="attachment-gallery-item">
                      <figure>
                        <Image src="./assets/images/agent-1.png" alt="Image" preview />
                      </figure>
                      <div className="content">
                        <p>Jul 10 at 10:00 am</p>
                        <span className="attachment-agent-name">RK</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          {sub_tasks.map((eachSubtask, index) => (
            <div key={eachSubtask.id} className="tab-pane fade" id={`subtask-${index + 1}`} role="tabpanel" aria-labelledby="subtask-tab" tabIndex={index + 1}>
              <h2>{eachSubtask.title}</h2>
              <form>
                <div className="form-group-grid">
                  <div className="form-group">
                    <label className="form-label">
                      <i className="ri-creative-commons-sa-line"></i> Status
                    </label>
                    <select className="form-select" aria-label="Default select example">
                      <option defaultValue>Todo</option>
                      <option value="1">Testing</option>
                      <option value="2">New</option>
                      <option value="3">Complete</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      <i className="ri-user-line"></i> Assignees
                    </label>
                    <select className="form-select">
                      <option defaultValue>Empty</option>
                      <option value="1">Name</option>
                      <option value="2">Name</option>
                      <option value="3">Name</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      <i className="ri-calendar-2-fill"></i> Dates
                    </label>
                    <Calendar value={dates} readOnlyInput hideOnRangeSelection placeholder="Due" dateFormat="M dd, yy" showButtonBar showIcon />
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      <i className="ri-arrow-up-down-fill"></i> Relationships
                    </label>
                    <input type="text" className="form-control" placeholder="Empty" />
                  </div>
                </div>
                <div className="form-group mb-5 mt-3">
                  <Editor value={text} onTextChange={(e) => setText(e.htmlValue)} className="texteditor" />
                </div>

                <div className="subtasks-list" role="tablist">
                  <button
                    className="nav-link active"
                    id="customField-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#customField"
                    type="button"
                    role="tab"
                    aria-controls="customField"
                    aria-selected="true"
                  >
                    Custom Fields
                  </button>
                  <button
                    className="nav-link"
                    id="AttachmentTab-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#AttachmentTab"
                    type="button"
                    role="tab"
                    aria-controls="AttachmentTab"
                    aria-selected="false"
                  >
                    Attachments
                  </button>
                </div>
                <div className="tab-content">
                  <div className="tab-pane fade show active" id="customField" role="tabpanel" aria-labelledby="customField-tab" tabIndex="0">
                    <ul className="custom-field-list">
                      <li>
                        <i className="ri-text"></i> Name
                      </li>
                      <li>
                        <i className="ri-phone-line"></i> Phone
                      </li>
                      <li>
                        <i className="ri-mail-line"></i> Email
                      </li>
                      <li>
                        <i className="ri-global-line"></i> Website
                      </li>
                    </ul>
                    <button className="custom-field-add-btn">
                      <i className="ri-add-line"></i> Create Custom Fields
                    </button>
                  </div>
                  <div className="tab-pane fade" id="AttachmentTab" role="tabpanel" aria-labelledby="AttachmentTab-tab" tabIndex="1">
                    <div className="attachment-gallery">
                      <div className="attachment-gallery-item">
                        <figure>
                          <Image src="./assets/images/customer-bg.jpg" alt="Image" preview />
                        </figure>
                        <div className="content">
                          <p>Jul 10 at 10:00 am</p>
                          <span className="attachment-agent-name">RK</span>
                        </div>
                      </div>
                      <div className="attachment-gallery-item">
                        <figure>
                          <Image src="./assets/images/agent-1.png" alt="Image" preview />
                        </figure>
                        <div className="content">
                          <p>Jul 10 at 10:00 am</p>
                          <span className="attachment-agent-name">RK</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          ))}
        </div>
      );
    };
    return (
      <>
        {getModalLayout !== 2 && (
          <div id="popupSidebar" className="popup-sidebar hide-in-sidebar">
            <h5>
              <i className="ri-git-merge-line"></i> Subtasks
            </h5>
            <ul className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
              <li>
                <button className="nav-link active" id="task-data-tab" data-bs-toggle="pill" data-bs-target="#task-data" type="button" role="tab" aria-controls="task-data" aria-selected="true">
                  {title}
                </button>
              </li>
              {sub_tasks.map((eachSubtask, index) => (
                <li>
                  <button
                    className="nav-link"
                    id={`subtask-tab-${index + 1}`}
                    data-bs-toggle="pill"
                    data-bs-target={`#subtask-${index + 1}`}
                    type="button"
                    role="tab"
                    aria-controls={`subtask-${index + 1}`}
                    aria-selected="true"
                  >
                    {eachSubtask.title}
                  </button>
                </li>
              ))}

              <li>
                <button className="nav-link">Add Sub task</button>
              </li>
            </ul>
          </div>
        )}
        <div id="popupContentGrid" className="popup-content-grid">
          {getModalLayout !== 2 && <div className="popup-center-content hide-in-sidebar">{renderTaskDetailLayout()}</div>}
          <div id="activitySidebar" className="activity-bar activity-bar-small">
            {activityTab === 0 && getModalLayout === 2 && <div className="popup-center-content">{renderTaskDetailLayout()}</div>}
            {activityTab === 1 && (
              <>
                <h4>Activity</h4>
                <div className="activity-bar-content">
                  <ul className="history-list">
                    <li className="mb-2">
                      Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                    <li className="mb-2">
                      Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                    <li className="mb-2">
                      Lead due date changed recently Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                    <li className="mb-2">
                      Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                    <li className="mb-2">
                      Lead due date changed recently Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                  </ul>
                </div>
              </>
            )}
            {activityTab === 2 && (
              <>
                <h4>Email</h4>
                <div className="activity-bar-content">
                  <div className={`smallEditor ${activeEditor ? "active" : ""}`}>
                    <Editor
                      value={text}
                      placeholder="Enter your text here"
                      onFocus={() => setActiveEditor(true)}
                      onBlur={() => setActiveEditor(false)}
                      onTextChange={(e) => setText(e.htmlValue)}
                      modules={customModules}
                      className="texteditor"
                    />
                    <button type="button" className="submit-btn">
                      Send
                    </button>
                  </div>
                </div>
              </>
            )}
            {activityTab === 3 && <h4>Links</h4>}
            {activityTab === 4 && (
              <>
                <h4>Notes</h4>
                <div className="activity-bar-content">
                  <div className={`smallEditor ${activeEditor ? "active" : ""}`}>
                    <Editor
                      value={text}
                      placeholder="Enter your text here"
                      onFocus={() => setActiveEditor(true)}
                      onBlur={() => setActiveEditor(false)}
                      onTextChange={(e) => setText(e.htmlValue)}
                      modules={customModules}
                      className="texteditor"
                    />
                    <button type="button" className="submit-btn">
                      Send
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="activity-bar-ribbon">
          <div className="activity-list">
            {getModalLayout === 2 && (
              <button
                onClick={() => {
                  setActivityTab(0);
                }}
                className={activityTab === 0 ? "activityInfo-button active" : "activityInfo-button"}
              >
                <i className="ri-align-left"></i>
                <span>Details</span>
              </button>
            )}
            <button
              onClick={() => {
                setActivityTab(1);
              }}
              className={activityTab === 1 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-chat-4-line"></i>
              <span>Activity</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(2);
              }}
              className={activityTab === 2 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-mail-line"></i>
              <span>Email</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(3);
              }}
              className={activityTab === 3 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-attachment-2"></i>
              <span>Links</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(4);
              }}
              className={activityTab === 4 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-add-line"></i>
              <span>Notes</span>
            </button>
          </div>
        </div>
      </>
    );
  };

  const onClickTaskDetail = (task, id) => {
    const modifiedData = viewTask.filter((lead) => lead.id === id);
    if (modifiedData.length === 0) {
      setViewTask((prevState) => [...prevState, task]);
    }
  };

  return (
    <div className="page-content tasks-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="task-page-header">
              <div className="task-page-header-left">
                <button
                  type="button"
                  className={taskView === "List" ? "btn active" : "btn"}
                  onClick={() => {
                    setTaskView("List");
                  }}
                >
                  <i className="ri-list-check"></i>
                  List
                </button>
                <button
                  type="button"
                  className={taskView === "Board" ? "btn active" : "btn"}
                  onClick={() => {
                    setTaskView("Board");
                  }}
                >
                  <i className="ri-dashboard-line"></i>
                  Board
                </button>
                <button
                  type="button"
                  className={taskView === "Calendar" ? "btn active" : "btn"}
                  onClick={() => {
                    setTaskView("Calendar");
                  }}
                >
                  <i className="ri-calendar-2-line"></i>
                  Calendar
                </button>
              </div>
              <div className="task-page-header-right"></div>
            </div>
          </div>
        </div>
        {taskView === "List" && <TaskList taskList={taskList} modifiedTaskDetails={modifiedTaskDetails} setModifiedTaskDetails={setModifiedTaskDetails} onClickTaskDetail={onClickTaskDetail} />}
        {taskView === "Board" && <TaskBoards taskList={taskList} />}
        {taskView === "Calendar" && (
          <div className="calendar-view">
            <EventCalendar events={events} taskList={taskList} />
          </div>
        )}
      </div>

      <div className="minimize-grid">
        {viewTask.length >= 1 &&
          viewTask.map((item) => (
            <CustomModal
              key={item.id}
              renderItem={() => renderTaskDetails(item)}
              title={"Task Overview"}
              secondaryTitle={item.title}
              visible={true}
              showLeftSidebarIcon={true}
              showCreateDate={true}
              showMoreIcon={true}
              createdDate={formatDateTimeNew(item.created_at)}
              showLayoutIcon={viewTask.length === 1}
              getModalLayout={setGetModalLayout}
              onHandleClose={() => {
                const modifiedData = viewTask.filter((task) => task.id !== item.id);
                setViewTask(modifiedData);
              }}
            />
          ))}
      </div>
    </div>
  );
};

export default Tasks;
